import type { CSSProperties } from "react";

/** 空间首页权益卡片：续订 / 订阅更多按钮（Web） */
export interface SpaceHomeMembershipRenewButtonConfig {
  /** 按钮宽度（px，对应 CSS min-width，文案较长时可撑开） */
  width: number;
  /** 按钮高度（px） */
  height: number;
  /** 文案字号（px） */
  fontSize: number;
  /** 左右内边距（px）；不设则随高度自动留白 */
  paddingX?: number;
}

export const SPACE_HOME_MEMBERSHIP_RENEW_BUTTON = {
  width: 80,
  height: 28,
  fontSize: 14,
  paddingX: 18,
} as const satisfies SpaceHomeMembershipRenewButtonConfig;

export function spaceHomeMembershipRenewButtonCssVars(
  config: SpaceHomeMembershipRenewButtonConfig = SPACE_HOME_MEMBERSHIP_RENEW_BUTTON
): CSSProperties {
  const paddingX = config.paddingX ?? Math.max(12, Math.round(config.height * 0.5));
  return {
    ["--lf-space-membership-renew-btn-width" as string]: `${config.width}px`,
    ["--lf-space-membership-renew-btn-height" as string]: `${config.height}px`,
    ["--lf-space-membership-renew-btn-font-size" as string]: `${config.fontSize}px`,
    ["--lf-space-membership-renew-btn-padding-x" as string]: `${paddingX}px`,
  };
}
